import { defineStore } from 'pinia'

export const useAppUtilityStore = defineStore('appUtilityStore', () => {
  const app = useNuxtApp()
  const store = app.$store

  // calculate state for isInMobileApp, state is hydrated from ssr to the client in the pinia stores automatically
  const inMobileApp = useState<boolean>('isInMobileApp', () => {
    let userAgent: string = ''
    if (import.meta.server && app.ssrContext)
      userAgent = app.ssrContext.event.node.req.headers['user-agent'] || ''
    else userAgent = navigator.userAgent

    const inMobileApp =
      userAgent &&
      userAgent
        .split(' ')
        .some((substring) => substring.startsWith('wa-mobile-app'))

    return inMobileApp
  })

  store?.dispatch('setInMobileApp', inMobileApp)

  return {
    inMobileApp,
  }
})
